import {
    Component,
    Input,
    Output,
    OnInit,
    EventEmitter,
    ViewChild
} from '@angular/core';

import { Observable } from 'rxjs';

import { AbstractDialogComponent } from '../../../../Core/Dialogs/components/AbstractDialog/abstract-dialog.component';
import { CoreDialogService } from '../../../../Core/Dialogs/services/dialog.service';
import { FullProfileAnimationModel } from '../../../../Core/Dialogs/models/full-profile-animation.model';
import { ButtonTypesEnum } from '../../../Forms/enums/button-types.enum';
import { RichTextEditorConfigModel } from '../../../Forms/components/RichTextEditorCK/model/rich-text-editor-config.model';
import { PersonalizationTagEnum } from '../../../../Discover/Targeting/enums/personalization-tag.enum';
import { ScrollPanelComponent } from '../../../Basic/components/ScrollPanel/scroll-panel.component';


@Component({
    selector: 'agpr-rich-text-editor-dialog',
    templateUrl: './rich-text-editor-dialog.component.html',
    styleUrls: ['./rich-text-editor-dialog.component.scss'],
    standalone: false
})
export class RichTextEditorDialogComponent extends AbstractDialogComponent implements OnInit {

    @Input() personalizationType: PersonalizationTagEnum.INTRO | PersonalizationTagEnum.OUTRO;
    @Input() content: string = '';

    @Input() animationTrigger: Observable<FullProfileAnimationModel>;
    @Input() overlayContainer: Element;

    @Output() contentChanges = new EventEmitter<string>();

    @ViewChild('rightScrollPanel') rightScrollPanel: ScrollPanelComponent;

    ckEditorConfig: RichTextEditorConfigModel;
    isTextExceedingLimit: boolean = false;

    readonly id = 'RichTextEditorDialog';
    readonly buttonType = ButtonTypesEnum;
    readonly personalizationEnum = PersonalizationTagEnum;
    readonly personalizationTypeLabelMap = new Map<PersonalizationTagEnum, string>([
        [PersonalizationTagEnum.INTRO, 'Discover.distribution.personalizationWorkbench.intro'],
        [PersonalizationTagEnum.OUTRO, 'Discover.distribution.personalizationWorkbench.outro'],
    ]);

    constructor(
        public coreDialogService: CoreDialogService,
    ) {
        super(coreDialogService, 'RichTextEditorDialog');
    }

    ngOnInit() {
        this.ckEditorConfig = new RichTextEditorConfigModel({
            enableInsertImage: false,
            enableLineHeight: false,
            enableFontColor: false,
            enableBackgroundColor: false,
            enableHtmlEditor: false,
            enableFontFamily: false,
            enableFontSize: false,
            enableBlockQuote: false,
            enableHeading: false,
            enableAlignment: false,
            enableDirection: false,
            enableIndent: false,
            enableAIRefinement: true,
            enableAIHelper: false,
            enableTranslation: false,
            hideInsert: true,
            aiReferenceId: ''
        });
    }

    use() {
        this.contentChanges.emit(this.content);
        this.closeDialog();
    }
    /** Encode content string into utf-8 byte stream,
     * throw error if greater then 3000 bytes
    */
    checkErrors() {
        const encoder = new TextEncoder();
        const byteArray = encoder.encode(this.content);
        this.isTextExceedingLimit = byteArray.length > 3000;

        if (this.isTextExceedingLimit) {
            requestAnimationFrame(() => {
                const content = document.querySelector('#generated_content');
                const listener = new ResizeObserver((entries) => {
                    if (this.rightScrollPanel?.contentDoesVerticalScroll()) {
                        this.rightScrollPanel.scrollTo(entries[0].contentRect.bottom);
                    }
                });
                if (listener && content) {
                    listener.observe(content);
                }
            });
        }
    }

    close() {
        this.closeDialog();
    }
}
